import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Axios from 'axios';
import i18next from 'i18next';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ConsultaAPI } from '../../../../shared/http-requests';
import { useSearchContext } from '../../../../shared/contexts/SearchContextProvider';
import { useAccessibilityContext } from '../../../consulta-acessibilidade/contexts/AccessibilityContext';
import { useLocation } from 'react-router-dom';
import { ToastifyHelper } from '../../../../shared/helpers';
import shortid from 'shortid';
import { Store } from '../../../../store';
import { changeSearchOptions } from '../../../../store/ducks/pesquisa';

function padArray(arr, size, fillValue) {
    if (!Array.isArray(arr)) {
        throw new Error('O argumento "arr" deve ser um array.');
    }

    const oldArray = [...JSON.parse(JSON.stringify(arr))];
    const newArr = []

    for(let i = 0; i < size; i++){
        if(oldArray.length-1 >= i){
            newArr.push(oldArray[i])
        }else{
            newArr.push(JSON.parse(JSON.stringify(fillValue)))
        }
    }

    return newArr;
}

const PesquisaJurisprudencia = props => {
    const { t } = useTranslation();
    const [opcoes, setOpcoes] = useState([]);
    const { opcoesConsulta } = props;
    const [searching, setSearching] = useState(false);
    const [typeOfAtos, setTypeOfAtos] = useState(null);
    const [comparacao, setComparacao] = useState('-1');
    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');
    const [tipo, setTipo] = useState('');
    const [permissionFilters, setPermissionFilters] = useState(false);

    const {search} = useLocation();

    const [initialDataFetched, setInitialDataFetched] = useState(false);
    const location = useLocation();

    const { search: searchFromContext, loadingSearch } = useSearchContext();
    const { searchInputRef } = useAccessibilityContext();

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(search);
        const comp = urlSearchParams.get('comparacao')
        const dtInicial = urlSearchParams.get('data_inicial')
        const dtFinal = urlSearchParams.get('data_final')
        const codTipoObra = urlSearchParams.get('cod_tipo_obra')

        if(comp)
            setComparacao(comp)

        if(dtInicial)
            setDataInicial(dtInicial)

        if(dtFinal)
            setDataFinal(dtFinal)

        if(codTipoObra)
            setTipo(codTipoObra)


    }, [search])

    useEffect(() => {
        ConsultaAPI.getPermissionFiltersAtosAndJurisprudencia().then(response => {
            const { data } = response;
            if(data){
                const { permission } = data;
                setPermissionFilters(permission)
                if(permission){
                    ConsultaAPI.getTypeOptionsJurisprudenciaSearch().then((response) => {
                        const { data } = response;
                        if(data){
                            setTypeOfAtos(data)
                        }
                    }).catch(error => {
                        console.error(error)
                    })
                }
            }
        }).catch((error) => {
            console.error(error)
        })
    }, [])


    const [localOpcoesConsulta, setLocalOpcoesConsulta] =
        useState([
            {
                fieldIndex: 1,
                option: null,
                termo: '',
            },
            {
                fieldIndex: 2,
                option: null,
                termo: '',
            },
            {
                fieldIndex: 3,
                option: null,
                termo: '',
            },
        ]);

    useEffect(() => {
        if(opcoesConsulta?.length > 0 && opcoes?.length > 0) {
            const newLocalConsultaData=  padArray(opcoesConsulta, 3, {
                option: null,
                termo: '',
            }).map((x, i) => {
                x.fieldIndex = i+1;

                if(x.option === null){
                    switch (i){
                        case 0:
                            x.option = opcoes[0]?.codigo;
                            break;
                        case 1:
                            x.option = opcoes[1]?.codigo;
                            break;
                        case 2:
                            x.option = opcoes[2]?.codigo;
                            break;
                    }
                }

                return x;
            })

            setLocalOpcoesConsulta(newLocalConsultaData)
        }else{
            setLocalOpcoesConsulta([
                {
                    fieldIndex: 1,
                    option: 'obra',
                    termo: '',
                },
                {
                    fieldIndex: 2,
                    option: 'obra',
                    termo: '',
                },
                {
                    fieldIndex: 3,
                    option: 'obra',
                    termo: '',
                }
            ])
        }
    }, [opcoesConsulta, opcoes, initialDataFetched])

    //Busca inicial
    useEffect(() => {
        if(opcoesConsulta && opcoesConsulta.length === 1 && opcoesConsulta[0].option === null && opcoesConsulta[0].termo?.trim() === ""){
            ConsultaAPI.legislacaoAutoSearchPermission().then((response) => {
                if(response){
                    const { data } = response;

                    if(data && data?.permission === true){
                        if(!initialDataFetched){
                            ConsultaAPI.buscarConsulta('jurisprudencia', {
                                tipo_termos: 'U',
                                coluna_um: '-1',
                                search_id: shortid(),
                                search_tab: "jurisprudencia",
                                termo_pesquisa: '-1',
                                last_added: true
                            }, location)
                        }
                        setInitialDataFetched(true)
                    }
                }
            }).catch((e) => {
                console.log(e)
            })
        }
    }, [opcoesConsulta, loadingSearch]);

    // ? Valores dentro do select de condicoes:
    const condicoes = [
        { label: t('AND'), value: 'AND', intermediario: false },
        { label: t('OR'), value: 'OR', intermediario: false },
        { label: t('NOT'), value: 'NOT', intermediario: false },
        { label: t('AFT'), value: 'AFT', intermediario: true },
        { label: t('BEF'), value: 'BEF', intermediario: true },
    ];

    // useEffect(() => {
    //     const allowToSearch = localOpcoesConsulta.filter(x => x.termo !== '');
    //     Store.dispatch(changeSearchOptions(allowToSearch));
    // }, [localOpcoesConsulta]);

    useEffect(() => {
        const cancelToken = Axios.CancelToken.source();
        ConsultaAPI.getOptionsJurisprudencia(cancelToken.token)
            .then(response => {
                setOpcoes(response.data);
                response.data.forEach(d => {
                    // Coloca as descrições da combo na internacionalização para ser utilizado em outras labels da aplicação.
                    i18next.addResource(
                        'pt',
                        'translation',
                        d.codigo,
                        d.descricao,
                    );
                    i18next.addResource(
                        'en',
                        'translation',
                        d.codigo,
                        d.descricao,
                    );
                    i18next.addResource(
                        'es',
                        'translation',
                        d.codigo,
                        d.descricao,
                    );
                });
            })
            .catch(error => {
                if (!Axios.isCancel(error)) return;
            });
        // ? cleanup
        return () => {
            Store.dispatch(changeSearchOptions([]));
            cancelToken.cancel();
        }
    }, []);

    const handleChangeComboTermo = (e, index) => {
        e.preventDefault();
        const valor = e.target.value;
        const optPesquisa = JSON.parse(JSON.stringify(localOpcoesConsulta));

        optPesquisa[index].option = valor;

        if (['AFT', 'BEF'].includes(optPesquisa[index].condition)) {
            optPesquisa[index + 1].option = valor;
        }

        setLocalOpcoesConsulta(optPesquisa);
        // return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const handleChangeTextTermo = (e, index) => {
        e.preventDefault();
        const valor = e.target.value;
        const optPesquisa = JSON.parse(JSON.stringify(localOpcoesConsulta));
        optPesquisa[index].termo = valor;
        setLocalOpcoesConsulta(optPesquisa);
        // return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const handleChangeComboCondicao = (e, index) => {
        e.preventDefault();
        const valor = e.target.value;
        const optPesquisa = JSON.parse(JSON.stringify(localOpcoesConsulta));
        optPesquisa[index].condition = valor;

        if (index === 0 && valor === '-1') {
            if (optPesquisa[1].termo?.trim() !== '') {
                optPesquisa[1].termo = '';
            }

            if (
                optPesquisa[1].condition !== undefined &&
                optPesquisa[1].condition !== '-1'
            ) {
                optPesquisa[1].condition = '-1';
            }

            if (optPesquisa[2].termo?.trim() !== '') {
                optPesquisa[2].termo = '';
            }
        } else if (
            index === 1 &&
            valor === '-1' &&
            optPesquisa[2].termo?.trim() !== ''
        ) {
            optPesquisa[2].termo = '';
        } else if (['AFT', 'BEF'].includes(optPesquisa[0].condition)) {
            optPesquisa[2].termo = '';
            optPesquisa[1].condition = '-1';
        }

        // if (['AFT', 'BEF'].includes(valor)) {
        //     optPesquisa[index + 1].option = optPesquisa[index].option;
        // }
        setLocalOpcoesConsulta(optPesquisa);
        // return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const adicionarTermoPesquisa = () => {
        const optPesquisa = JSON.parse(JSON.stringify(localOpcoesConsulta));
        optPesquisa.push({ option: 'obra', termo: '' });
        setLocalOpcoesConsulta(optPesquisa);
        // return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const removerTermoPesquisa = index => {
        const optPesquisa = JSON.parse(JSON.stringify(localOpcoesConsulta));
        if (!optPesquisa[index + 1]) {
            optPesquisa[index - 1].condition = undefined;
        }
        optPesquisa.splice(index, 1);
        setLocalOpcoesConsulta(optPesquisa);
        // return Store.dispatch(changeSearchOptions(optPesquisa));
    };

    const getCondicoes = indexLinha => {
        /* PRIMEIRA LINHA */
        if (indexLinha === 0) {
            return condicoes.map(condicao => (
                <option key={`cond-${condicao.value}`} value={condicao.value}>
                    {condicao.label}
                </option>
            ));
        }
        return condicoes
            .filter(c => !c.intermediario)
            .map(condicao => (
                <option key={`cond-${condicao.value}`} value={condicao.value}>
                    {condicao.label}
                </option>
            ));
    };

    const localValidate = () => {
        const currentLocalOpcoesConsulta = JSON.parse(
            JSON.stringify(localOpcoesConsulta),
        ).map((x, i) => {
            x.fieldIndex = i + 1;
            x.error = false;
            return x;
        });

        currentLocalOpcoesConsulta.forEach(x => {
            if (x.fieldIndex === 1) {
                if (x.termo.trim() === '') {
                    x.error = true;
                }
            }

            if (x.fieldIndex === 2) {
                if (
                    x.termo?.trim() === '' &&
                    currentLocalOpcoesConsulta[0].condition !== undefined &&
                    currentLocalOpcoesConsulta[0].condition !== '-1'
                ) {
                    x.error = true;
                }
            }

            if (x.fieldIndex === 3) {
                if (
                    x.termo?.trim() === '' &&
                    currentLocalOpcoesConsulta[1].condition !== undefined &&
                    currentLocalOpcoesConsulta[1].condition !== '-1'
                ) {
                    x.error = true;
                }
            }
        });

        const errors = [];

        if(comparacao !== '-1'){

            if(!dataInicial){
                errors.push(`É necessário informar o campo:  '${t('AnoPublicacao')}' `)
            }

            if(comparacao === 'entre'){
                if(!dataFinal){
                    errors.push(`É necessário informar o campo:  '${t('AnoPublicacaoFinal')}' `)
                }else if(dataFinal < dataInicial){
                    errors.push(`O campo '${t('AnoPublicacaoFinal')}' não pode ser menor que '${t('AnoPublicacao')}'`)
                }
            }

        }

        if(errors.length > 0){
            errors.forEach(error => {
                ToastifyHelper.error(error)
            })
            return false;
        }


        setLocalOpcoesConsulta(currentLocalOpcoesConsulta);
        return currentLocalOpcoesConsulta.every(x => !x.error);
    };

    const handleClickSearch = e => {
        e.preventDefault();

        if (!localValidate()) {
            return;
        }

        const currentLocalOpcoesConsulta = JSON.parse(
            JSON.stringify(localOpcoesConsulta),
        )?.filter(x => x.termo !== '');



        const map = ['um', 'dois', 'tres']
        const data = {}
        const queryParams = {};

        currentLocalOpcoesConsulta.filter(x => x.termo !== '').forEach((item, index) => {
            data[`coluna_${map[index]}`] = item.option;
            queryParams[`for${index  === 0 ? '' : index +1}`] = item.option

            if(index === 0){
                queryParams.q = item.termo
                data.termo_pesquisa = item.termo
            } else{
                queryParams[`q${index + 1}`] = item.termo
                data[`termo_pesquisa_${map[index]}`] =  item.termo;
            }

            if(item?.condition){
                data[`condicao_${map[index]}`] = item.condition
                queryParams[`condition${index === 0 ? '' : index+1}`] = item.condition
            }
        })

        searchFromContext(data, queryParams);
        //setTimeout(() => document.querySelector('#consultar').submit(), 100);
    };

    const getRuleCondition = (index, opcao) => {
        if (searching) {
            return ![undefined, '-1'].includes(opcao.condition) && index < 2;
        }
        return index < 2;
    };

    let fieldContainerStyles = {};

    if (searching) {
        fieldContainerStyles = {
            visibility: searching ? 'hidden' : 'visible',
            height: searching ? '0px' : 'auto',
            width: searching ? '0px' : 'auto',
            margin: searching ? '0px' : 'auto',
            padding: searching ? '0px' : 'auto',
        };
    }

    const handleOnChangeCondition = (e) => {
        const { value } = e.target;

        if(value === '-1'){
            setDataInicial('')
        }

        if(value !== 'entre'){
            setDataFinal('')
        }

        setComparacao(value)
    }


    return (
        <Row  className="content__left__input px-3">
            {searching ? (
                <Col md="10" xs="12" className="p-4">
                    <div
                        className="d-flex  align-items-center"
                        style={{
                            gap: '16px',
                            left: 0,
                            top: 0,
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <FontAwesomeIcon size="1x" icon={faSpinner} spin />
                        <span className="cortxt">
                            {t('RealizandoConsulta')}
                        </span>
                    </div>
                </Col>
            ) : (
                ''
            )}
            <Col style={fieldContainerStyles} md="10" xs="12">
                {localOpcoesConsulta &&
                    localOpcoesConsulta.map((opcao, index) => (
                        <Row
                            className={`w-100 ${
                                index !== 0 &&
                                'additional_search_input pl-sm-0 pl-2 pr-sm-0 pr-2'
                            }`}
                            key={`row-termo-${index}`}
                        >
                            <Col
                                sm="6"
                                md="3"
                                xs="12"
                                className="input-holder mt-3"
                            >
                                <div className='rotulo'>
                                    {t('PesquisarPor')}
                                </div>
                                <Input
                                    type="select"
                                    name={`for${index === 0 ? '' : index + 1}`}
                                    value={opcao.option ?? ''}
                                    onChange={e =>
                                        handleChangeComboTermo(e, index)
                                    }
                                    disabled={
                                        (index > 0 &&
                                            localOpcoesConsulta[index - 1]
                                                ?.condition === undefined) ||
                                        localOpcoesConsulta[index - 1]
                                            ?.condition === '-1'
                                    }
                                    readOnly={
                                        index > 0 &&
                                        ['AFT', 'BEF'].includes(
                                            localOpcoesConsulta[0].condition,
                                        )
                                    }
                                >
                                    {opcoes?.filter(x => {
                                        return !localOpcoesConsulta?.some((loc, i) => x.codigo?.toString()?.trim()?.toLowerCase() === 'livre' && x.codigo === loc.option && i !== index)
                                    })?.map(termo => (
                                        <option
                                            key={`opt-arquivo-${termo.codigo}`}
                                            value={termo.codigo}
                                        >
                                            {termo.descricao}
                                        </option>
                                    ))}
                                </Input>
                                <div className="invalid-feedback">
                                    {t('CampoBuscaObrigatorio')}
                                </div>
                            </Col>
                            <Col sm="6" xs="12" className="input-holder mt-3">
                                <div className='rotulo'>
                                    {t('CampoBusca')}
                                </div>
                                <Input
                                    innerRef={index === 0 ? searchInputRef : null}
                                    type="text"
                                    name={`q${index === 0 ? '' : index + 1}`}
                                    placeholder={t('DigiteSuaBuscaAqui')}
                                    className='foco rad10'
                                    disabled={
                                        (index === 2 &&
                                            ['AFT', 'BEF'].includes(
                                                localOpcoesConsulta[0]
                                                    .condition,
                                            )) ||
                                        (index > 0 &&
                                            localOpcoesConsulta[index - 1]
                                                ?.condition === undefined) ||
                                        localOpcoesConsulta[index - 1]
                                            ?.condition === '-1'
                                    }
                                    invalid={opcao?.error}
                                    value={opcao.termo || ''}
                                    onChange={e =>
                                        handleChangeTextTermo(e, index)
                                    }
                                />
                                <div className="invalid-feedback">
                                    {t('CampoBuscaObrigatorio')}
                                </div>
                            </Col>
                            {getRuleCondition(index, opcao) ? (
                                <Col
                                    xs="12"
                                    sm="6"
                                    md="2"
                                    className="mt-3 input-holder"
                                >
                                    <div className='rotulo'>
                                        {t('Condicionais')}
                                    </div>
                                    <Input
                                        type="select"
                                        disabled={
                                            (index === 1 &&
                                                ['AFT', 'BEF'].includes(
                                                    localOpcoesConsulta[0]
                                                        .condition,
                                                )) ||
                                            (index > 0 &&
                                                localOpcoesConsulta[index - 1]
                                                    ?.condition ===
                                                    undefined) ||
                                            localOpcoesConsulta[index - 1]
                                                ?.condition === '-1'
                                        }
                                        style={{
                                            display: 'inline',
                                        }}
                                        name={`condition${
                                            index === 0 ? '' : index + 1
                                        }`}
                                        value={opcao.condition || '-1'}
                                        onChange={e =>
                                            handleChangeComboCondicao(e, index)
                                        }
                                    >
                                        <option value="-1" />
                                        {getCondicoes(index)}
                                    </Input>
                                    <div className="invalid-feedback">
                                        {t('CampoBuscaObrigatorio')}
                                    </div>
                                </Col>
                            ) : (
                                ''
                            )}
                        </Row>
                    ))}
            </Col>
            {
                permissionFilters === true ? (
                    <Col style={fieldContainerStyles} className="pt-3" md="10" xs="12">
                        <Row>
                            <Col sm="3" xs="12">
                                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                <label htmlFor="cod_tipo_obra" className="mb-2 preto50">
                                    {t('Tipo')}
                                </label>
                                <Input
                                    onChange={e => setTipo(e.target.value)}
                                    value={tipo}
                                    name="cod_tipo_obra" type="select">
                                    <option  value="-1"></option>
                                    {typeOfAtos !== null && typeOfAtos?.length > 0
                                        ? typeOfAtos.map(
                                            (
                                                { cod_tipo_obra, desc_tipo_obra },
                                                i,
                                            ) => (
                                                <option
                                                    value={cod_tipo_obra}
                                                    key={`option-type-${i}`}
                                                >
                                                    {desc_tipo_obra}
                                                </option>
                                            ),
                                        )
                                        : ''}
                                </Input>
                            </Col>
                            <Col
                                sm="8"
                                xs="12"
                                className="w-100 additional_search_input pl-sm-0 pl-2 pr-sm-0 pr-2"
                            >
                                <Row>
                                    <Col sm="3" xs="12">
                                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                        <label
                                            htmlFor="condicao"
                                            className="mt-2 mt-sm-0 mb-2 preto50"
                                        >
                                            {t('Condicao')}
                                        </label>
                                        <Input
                                            onChange={handleOnChangeCondition}
                                            name="comparacao"
                                            type="select"
                                            value={comparacao}
                                        >
                                            <option value="-1"></option>
                                            <option value="=">{t('IgualA')}</option>
                                            <option value=">">{t('MaiorQue')}</option>
                                            <option value="<">{t('MenorQue')}</option>
                                            <option value="entre">{t('Entre')}</option>
                                        </Input>
                                    </Col>
                                    <Col sm="4" xs="12" className="">
                                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                        <label
                                            htmlFor="tipo_atos"
                                            className="mb-2 mt-2 mt-sm-0 preto50"
                                        >
                                            {t('AnoPublicacao')}
                                        </label>
                                        <Input
                                            value={dataInicial}
                                            onChange={e => setDataInicial(e.target.value)}
                                            disabled={comparacao === '-1'}
                                            name="data_inicial"
                                            type="number"
                                        />
                                    </Col>
                                    {comparacao === 'entre' ? (
                                        <Col sm="4" xs="12">
                                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                            <label
                                                htmlFor="tipo_atos"
                                                className="mb-2 mt-2 mt-sm-0 preto50"
                                            >
                                                {t('AnoPublicacaoFinal')}
                                            </label>
                                            <Input
                                                value={dataFinal}
                                                onChange={e => setDataFinal(e.target.value)}
                                                name="data_final" type="number" />
                                        </Col>
                                    ) : (
                                        ''
                                    )}
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                ) : ''
            }
            <Col
                md="2"
                xs="12"
                className={classnames(' mt-3', { 'mb-4': props.error })}
            >
                <button
                    onClick={handleClickSearch}
                    title={t('Pesquisar')}
                    type="submit"
                    className="btn-generic--primeiro ml-0 btn-responsivo mt-md-3 mt-0"
                    disabled={props.loading}
                >
                        <FontAwesomeIcon icon="search" className="r5" />
                        <span>{t('Pesquisar')}</span>
                </button>
            </Col>
        </Row>
    );
};

export default PesquisaJurisprudencia;
